<template>
  <react-wrapper :component="OwnershipAlerts" />
</template>

<script>
import ReactWrapper from "view/wrappers/react-wrapper";
import { OwnershipAlerts } from "react-migration/domains/dashboard/ownershipAlerts/OwnershipAlerts";

export default {
  components: {
    ReactWrapper,
  },
  computed: {
    OwnershipAlerts() {
      return OwnershipAlerts;
    },
  },
};
</script>
